import React from "react";
import {
    Chip,
    styled,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {CustomATage, splitPath} from "../ExternalSourceManagement/ExternalSourceTable";
import {convertDateToTimeString} from "../utils/cert-helper";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    // [`&.${tableCellClasses.head}`]: {
    //     backgroundColor: '#e3f2fd',
    // },
    fontWeight: 'bold',
}))

export default function NuccSpecialtyValueSetLogsTable (props) {

    const nuccLogs = props.nuccLogs;

    return (
        <TableContainer sx={{maxHeight: '600px', '& .MuiTableCell-root': {paddingLeft: '4px', paddingRight: '4px'}}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Data Source</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>Data Path</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Imported Record Count</StyledTableCell>
                        <StyledTableCell>Created Time</StyledTableCell>
                        <StyledTableCell sx={{ textAlign: 'center'}}>Status</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {nuccLogs && nuccLogs.map((log, i) => {
                        return (
                            <TableRow key={i}>
                                <TableCell>{log.datasource}</TableCell>
                                <TableCell sx={{ maxWidth: '200px'}}>{log.description}</TableCell>
                                <TableCell sx={{ maxWidth: '350px', wordBreak: 'break-all'}}>
                                    {splitPath(log.dataPath).map((path, i) => (
                                        <li key={i}><span className="textSpan"><CustomATage size='14px' path={path} /></span></li>
                                    ))}
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center'}}>{log.importedRecordCount}</TableCell>
                                <TableCell>{convertDateToTimeString(log.createdTs)}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {log.completed ? <Chip variant='outlined' label="COMPLETED" color="success" icon={<CheckCircleIcon/>}/>
                                        : <Chip label="UNCOMPLETED" color="warning" variant='outlined'/>}
                                </TableCell>
                            </TableRow>
                        )
                    })}

                </TableBody>

            </Table>
        </TableContainer>

    )
}